var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Multiselect",
    _vm._b(
      {
        ref: "multiselect",
        staticClass: "export-select",
        class: { "export-select--small": _vm.size === "sm" },
        attrs: {
          value: _vm.selectedOption,
          options: _vm.normalizedOptions,
          "track-by": "key",
          label: "label",
          "allow-empty": _vm.allowEmpty,
          "close-on-select": true,
          disabled: _vm.disabled,
          "max-height": _vm.maxHeight,
          placeholder: _vm.placeholder,
          searchable: _vm.searchable,
          "show-labels": false,
        },
        on: { input: _vm.handleInput },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function ({ option }) {
              return [
                _c("div", { staticClass: "export-select__option" }, [
                  _c("span", {
                    staticClass: "export-select__check",
                    class: {
                      "export-select__check--visible": _vm.isSelected(option),
                    },
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(option.label))]),
                ]),
              ]
            },
          },
          {
            key: "noResult",
            fn: function () {
              return [
                _c("span", { staticClass: "export-select__empty" }, [
                  _vm._v("No options found."),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "Multiselect",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }